/**
 * "Director of Facilities, Baker Group" — the line under a name on every screen that lists people.
 * Either half can be missing (DATA-06), and a comma with nothing after it looks like a bug.
 */
export function roleLine(jobTitle: string | null, company: string | null): string {
  return [jobTitle, company].filter(Boolean).join(', ');
}

/**
 * Initials for an avatar disc. Headshots are an asset (SPK-03) and asset storage is not wired
 * yet, so every avatar in the app is currently two letters on a sand disc.
 */
export function initialsFromName(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.at(0) ?? '')
    .join('')
    .toUpperCase();
}
